// @ helpers
const { formatText } = require('core/i18n').i18n;
const { buildWrittenList } = require('utilities/contactCenter/stringHelper');
// @ constants
const { DATE_FORMAT_DAY_NUMBER } = require('constants/index');
const { CC_PERIODICITY_RANGE_SPECIFICATION_DAYS } = require('constants/contactCenter/transfers');

const StringHelper = {

    buildCustomPeriodicityText(immStep) {
        const periodicityRangeQuantity = immStep.get('periodicityRangeQuantity');
        const customSelectedMonthDays = immStep.get('customSelectedMonthDays');
        const periodicityRangeSpecified = immStep.get('periodicityRangeSpecified');
        const day = immStep.get('date').format( DATE_FORMAT_DAY_NUMBER )

        let writtenListOfDates = day;

        if (periodicityRangeSpecified === CC_PERIODICITY_RANGE_SPECIFICATION_DAYS) {
            const selectedCustomDates = customSelectedMonthDays
                .map(day => day < 10 ? `0${day}`: day);
            writtenListOfDates = buildWrittenList(selectedCustomDates.toJS())
        }

        const repeatOfEveryKey = periodicityRangeQuantity == 1 ? 'periodicity-periodicityRepeatEveryMonth' : 'periodicity-periodicityRepeatEveryMonths';
        return formatText(repeatOfEveryKey, [ writtenListOfDates, periodicityRangeQuantity ]);
    }

}

module.exports = StringHelper;
